// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"7867":"css/admin-app.6923","9514":"css/app.6923"}[chunkId] + ".css";
};